<template>
  <div v-loading="loading">
    <breadcrumb :breadcrumb="breadcrumb"></breadcrumb>
    <div
      class="card_wrap"
      v-if="$menuList['SIS-Orders-GenerateWB'] && $shopData.isEscrow != 1"
    >
      <h5>{{ language("waybillManagement.title") }}</h5>
      <div class="card">
        <el-card shadow="never" class="card1">
          <h5>{{ language("waybillManagement.generateMasterWB") }}</h5>
          <el-button type="primary" class="button" @click="generate">{{
            language("waybillManagement.generate")
          }}</el-button>
          <h5 v-if="exportHistoryoptions.length > 0">
            {{ language("waybillManagement.LastVersion") }}:
            {{ exportHistoryoptions[0].timeCode }}
          </h5>
        </el-card>

        <el-card shadow="never" class="card2">
          <h5>{{ language("waybillManagement.exportHistory") }}</h5>
          <div>
            <el-select v-model="exportHistoryValue" placeholder clearable>
              <el-option
                v-for="item in exportHistoryoptions"
                :key="item.id"
                :label="item.timeCode + '      ' + item.mwbNum"
                :value="item.id"
              ></el-option>
            </el-select>
            <el-button type="primary" class="button" @click="exportMasterWB">{{
              language("waybillManagement.exportMasterWB")
            }}</el-button>
          </div>
        </el-card>
      </div>
    </div>

    <div class="card_wrap padding">
      <div class="card_wrap">
        <h5>{{ language("waybillManagement.searchWaybill") }}</h5>
        <div class="card">
          <div class="status">
            <status-card
              :dataArr="statusArr"
              labelWidth="133px"
              :title="language('waybillManagement.status')"
              @change="formChange1"
            ></status-card>
          </div>

          <div class="input">
            <el-card class="box-card" shadow="never">
              <div slot="header">
                <span
                  ><h4>{{ language("waybillManagement.period") }}</h4></span
                >
              </div>
              <div class="select_time">
                <div class="title">Order By:</div>
                <el-select
                  v-model="sort"
                  placeholder
                  clearable
                  @change="changeTime"
                >
                  <el-option
                    v-for="item in options"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
                <template v-if="sort == '' && (checkbox.length > 0 || timeArr)">
                  <div class="select_time_tips">
                    {{ language("orderQuery.selectTimeType") }}
                  </div>
                </template>
              </div>
              <div class="select_time">
                <div class="title">Sort:</div>
                <el-select
                  v-model="sort2"
                  placeholder
                  clearable
                  @change="changeTime"
                >
                  <el-option
                    v-for="item in options2"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
               
              </div>

              <div class="time_wrap">
                <div class="check_box">
                  <el-checkbox-group
                    v-model="checkbox"
                    :min="0"
                    :max="1"
                    @change="changeTime"
                  >
                    <el-checkbox
                      v-for="(items, index) in checkboxArr"
                      :label="items"
                      :key="index"
                      class="checkbox_items"
                      :disabled="timeArr ? true : false"
                      >{{ items }}</el-checkbox
                    >
                  </el-checkbox-group>
                </div>
                <div class="time">
                  <el-date-picker
                    v-model="timeArr"
                    type="datetimerange"
                    range-separator="-"
                    start-placeholder="StartDate"
                    end-placeholder="EndDate"
                    value-format="yyyy-MM-dd HH:mm:ss"
                    :disabled="checkbox.length > 0 ? true : false"
                    @change="changeTime"
                    :default-time="['00:00:00', '23:59:59']"
                  ></el-date-picker>
                  <!-- :default-time="['00:00:00', '23:59:59']" -->
                </div>
              </div>
            </el-card>
          </div>

          <div class="input">
            <input-card
              :title="language('orderQuery.transaction')"
              :dataArr="inputArr"
              labelPosition="top"
              @change="formChange3"
            ></input-card>
          </div>
        </div>
        <div class="tips">{{ language("waybillManagement.searchTips") }}</div>
        <div class="button_wrap">
          <el-button type="primary" @click="search">{{
            language("waybillManagement.search")
          }}</el-button>
        </div>
      </div>
    </div>

    <div class="table_wrap">
      <div class="count">
        <div class="title">
          {{ language("waybillManagement.results") }}: {{ results }}
          {{ language("waybillManagement.rows") }}
        </div>
        <page :total="results" @pageChange="pageChange" ref="page"></page>
      </div>
      <div class="button_box">
        <div class="button_wrap">
          <div class="title">{{ language("waybillManagement.action") }} :</div>
          <el-button type="primary" @click="PickingListByItem">{{
            language("waybillManagement.pickingList")
          }}</el-button>
          <el-button
            type="primary"
            v-if="$menuList['SIS-Orders-ChangeStatus-Confirm']"
            @click="PickingConfirm"
            >{{ language("waybillManagement.pickingConfirm") }}</el-button
          >
          <el-button
            type="primary"
            v-if="$shopData.isEscrow != 1"
            @click="printWB"
            >{{ language("waybillManagement.printWB") }}</el-button
          >

          <template v-if="$menuList['SIS-Oders-ChangeStatus-Acknowledged']">
            <el-button type="primary" @click="acknowledge">{{
              language("waybillManagement.acknowledge")
            }}</el-button>
          </template>

          <template
            v-if="
              $menuList['SIS-Orders-ChangeStatus-Picked'] &&
              $shopData.isEscrow != 1
            "
          >
            <el-button type="primary" @click="print">{{
              language("waybillManagement.pick")
            }}</el-button>
          </template>
        </div>
        <template
          v-if="
            ($menuList['SIS-Orders-ChangeStatus-Delay'] &&
              $shopData.isEscrow != 1) ||
            $menuList['SIS-Orders-ChangeStatus-Cancel']
          "
        >
          <div class="button_wrap button_wrap_2">
            <div class="title">{{ language("waybillManagement.other") }} :</div>

            <template v-if="$menuList['SIS-Orders-ChangeStatus-Cancel']">
              <el-button type="primary" @click="cancel">{{
                language("waybillManagement.cancel")
              }}</el-button>
            </template>

            <template
              v-if="
                $menuList['SIS-Orders-ChangeStatus-Delay'] &&
                $shopData.isEscrow != 1
              "
            >
              <el-button type="primary" @click="delay">{{
                language("waybillManagement.delay")
              }}</el-button>
            </template>
          </div>
        </template>
      </div>
      <cc-table
        :loadData="false"
        :config="table"
        :dataArr="dataArr"
        :params="params"
        :refeshParams="refeshTable"
        @selecting-result="selectingResult"
        :emptyText="language('waybillManagement.emptyText')"
        :showIndex="false"
        :buttonsWidth="110"
      ></cc-table>
    </div>

    <template v-if="dialog">
      <el-dialog
        :close-on-click-modal="false"
        :visible.sync="dialog"
        width="90%"
        append-to-body
      >
        <itmes :ids="ids"></itmes>
      </el-dialog>
    </template>
    <!-- 
    <el-dialog
      :title="language('waybillManagement.resent')"
      :visible.sync="dialogVisible"
      width="30%"
      append-to-body
      :close-on-click-modal="false"
    >
      <span>{{ resentText }}</span>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="dialogVisible = false">{{
          language("waybillManagement.confirm")
        }}</el-button>
      </span>
    </el-dialog> -->
  </div>
</template>
<script>
import breadcrumb from "../../components/breadcrumb";
import statusCard from "../../components/statusCard";
import inputCard from "../../components/inputCard";
import itmes from "./components/items";

import page from "../../components/page";

function expireTime(time) {
  let begin = new Date();
  let times = time.replace(/\-/g, "/");
  let end = new Date(times);
  let span = end.getTime() - begin.getTime();
  let result = "";
  if (end.getTime() > begin.getTime()) {
    let days = Math.floor(span / (24 * 3600 * 1000));
    if (days > 0) {
      result += days + "天 ";
    }

    let leave1 = span % (24 * 3600 * 1000);
    //相差小时数
    let hours = Math.floor(leave1 / (3600 * 1000));
    result += conver(hours) + ":";
    // //相差分钟
    let leave2 = leave1 % (3600 * 1000);
    let minutes = Math.floor(leave2 / (60 * 1000));
    result += conver(minutes) + ":";
    //相差秒
    let leave3 = leave2 % (60 * 1000);
    let seconds = Math.round(leave3 / 1000);
    result += conver(seconds);
    return result;
  } else {
    return "超時";
  }
}
function getDateGE(day) {
  var today = new Date();
  var targetday_milliseconds = today.getTime() + 1000 * 60 * 60 * 24 * day;
  today.setTime(targetday_milliseconds);
  var tYear = today.getFullYear();
  var tMonth = today.getMonth();
  var tDate = today.getDate();
  tMonth = tMonth + 1;
  tDate = tDate;
  return tYear + "-" + tMonth + "-" + tDate;
  // return today.getTime();
}
var status = [
  "confirmed",
  "resent",
  "acknowledged",
  "picked",
  "delayedPKU",
  "cancelPKU",
  "expiredPKU",
  "cancelSYS",
  "deliveredTMP",
  "delayedDL",
  "expiredDL",
  "delivered",
  "",
  "",
  "created",
  "confirmed-SIS",
];
export default {
  components: {
    breadcrumb,
    page,
    statusCard,
    inputCard,
    itmes,
  },
  data() {
    return {
      shopData: {},
      dialog: false,
      breadcrumb: {
        title: this.language("waybillManagement.breadcrumbTitle"),
        list: [
          {
            name: this.language("waybillManagement.breadcrumbList_1"),
          },
          {
            name: this.language("waybillManagement.breadcrumbList_2"),
          },
        ],
      },
      exportHistoryoptions: [],
      exportHistoryValue: "",
      statusArr: [
        {
          title: "Non-Picked",
          checkbox: [],
          list: [
            {
              name: "Created",
              apiName: "Created",
              value: "14",
            },
            {
              name: " Confirmed-SIS",
              apiName: " Confirmed-SIS",
              value: "15",
            },
            {
              name: "Confirmed",
              apiName: "Confirmed",
              value: "0",
            },
            {
              name: "Resent",
              apiName: "Resent",
              value: "1",
            },
            {
              name: "Delayed-PKU",
              apiName: "Delayed-PKU",
              value: "4",
            },
            {
              name: "Acknowledged",
              apiName: "Acknowledged",
              value: "2",
            },
          ],
        },
        {
          title: "Non-Delivered",
          checkbox: [],
          list: [
            {
              name: "Picked",
              apiName: "Picked",
              value: "3",
            },
            {
              name: "Delayed",
              apiName: "Delayed",
              value: "9",
            },
          ],
        },
        {
          title: "Others",
          checkbox: [],
          list: [
            {
              name: "Delivered",
              apiName: "Delivered",
              value: "11",
            },
            {
              name: "Cancel-PKU",
              apiName: "Cancel-PKU",
              value: "5",
            },
            {
              name: "Expired-PKU",
              apiName: "Expired-PKU",
              value: "6",
            },
            {
              name: "Delieved-TMP",
              apiName: "Delieved-TMP",
              value: "8",
            },
            {
              name: "Cancel-SYS",
              apiName: "Cancel-SYS",
              value: "7",
            },
            {
              name: "Expired-DL",
              apiName: "Expired-DL",
              value: "10",
            },
          ],
        },
      ],
      sort: "",
      options: [
        {
          value: "order_time",
          label: "By Order Date",
        },
        {
          label: "By WB Receive Date",
          value: "create_time",
        },
        {
          label: "By Pick Up Due Date",
          value: "pick_up_due_time",
        },
        {
          label: "By Pick Up Date",
          value: "pick_up_Time",
        },
        {
          label: "By Delivery Due Date",
          value: "deliver_due_time",
        },
        {
          label: "By Delivery Date",
          value: "deliver_time",
        },
        {
          label: "Mch Confirm Due Date",
          value: "out_pick_confirm_due_time",
        },
        {
          label: "Mch Confirm Date",
          value: "out_pick_confirm_time",
        },
      ],
      //排序
      sort2:"DESC",
      options2:[
        {
          value: "DESC",
          label: "DESC",
        },
        {
          value: "ASC",
          label: "ASC",
         
        },
      ],
      checkboxArr: [
        "Today",
        "Yesterday",
        "Recent 3 Days",
        "Recent 7 Days",
        "Recent 14 Days",
      ],
      checkbox: [],
      timeArr: undefined,

      inputArr: [
        {
          name: "Query ID",
          apiName: "orderId",
          value: "",
        },
        {
          name: "Waybill Number",
          apiName: "wbNum",
          value: "",
        },
      ],
      table: {
        api: "admin/merchant/waybill/query",
        showPager: false,
        selection: true,
        selectionNoSubmit: true,
        selectingResult: true,
        indexFixed: "left",
        columns: [
          {
            prop: "orderTime",
            lable: "Order Date",
            minWidth: 200,
          },
          {
            prop: "orderId",
            lable: "Master Order ID",
            minWidth: 150,
          },
          {
            prop: "subNum",
            lable: "Order ID",
            minWidth: 140,
            render: (rows) => {
              return rows.orderId + "-" + rows.subNum;
            },
          },
          {
            prop: "wbNum",
            lable: "Waybill No.",
            minWidth: 135,
          },
          {
            prop: "mwbNum",
            lable: "MWB",
            minWidth: 135,
          },
          {
            prop: "pickingType",
            lable: "Picking Type",
            render: (row) => {
              var type = "";
              switch (row.pickingType) {
                case "in":
                  type = "In-Store";
                  break;
                case "out":
                  type = "Out-Of-Store";
                  break;
              }
              return type;
            },
            minWidth: 140,
          },
          {
            prop: "status",
            lable: "Status",
            render: (row) => {
              return status[row.status];
            },
            minWidth: 105,
          },
          {
            prop: "createTime",
            lable: "WB Received Date",
            minWidth: 220,
          },
          {
            prop: "outPickConfirmDueTime",
            lable: "Mch Confirm Due Date",
            minWidth: 220,
          },
          {
            prop: "outPickConfirmTime",
            lable: "Mch Confirm Date",
            minWidth: 220,
          },
          {
            prop: "pickUpDueTime",
            lable: "Pick Up Due Date",
            minWidth: 220,
          },
          {
            prop: "pickUpTime",
            lable: "Pick Up Date",
            minWidth: 220,
          },
          {
            prop: "deliverTime",
            lable: "Delivery Date",
            minWidth: 220,
          },
          {
            prop: "deliverDueTime",
            lable: "Delivery Due Date",
            minWidth: 220,
          },
          {
            prop: "updateTime",
            lable: "Last Updated",
            minWidth: 220,
          },
          {
            prop: "adminName",
            lable: "Updated By",
            minWidth: 120,
          },
          {
            prop: "resentRemark",
            lable: "Resent Remark",
            minWidth: 300,
            // type: "component",
            // componentName: resentRemark,
          },
        ],
        buttons: [
          // {
          //   name: this.language("waybillManagement.resent"),
          //   click: (row, index) => {
          //     this.dialogVisible = true;
          //     this.resentText =
          //       row.resentRemark ||
          //       this.language("waybillManagement.resentNull");
          //   },
          //   check: (row) => {
          //     if (row.status == 1) {
          //       return true;
          //     } else {
          //       return false;
          //     }
          //   },
          // },
        ],
      },
      params: {},
      refeshTable: -1,
      form: {
        pageSize: 10,
        pageNo: 1,
      },
      loading: false,
      dataArr: [],
      results: 0,
      form1: {},
      form3: {},
      form2: {},
      ids: [],
      resentText: "",
      dialogVisible: false,
    };
  },
  methods: {
    getExportHistoryoptions() {
      this.ccRequest
        .do(
          "admin/merchant/waybill/masterWayBill/query?sort=createTime",
          {
            shopNum: this.$shopData.shopNum,
            mchShopNum: this.$shopData.shopNum,
            pageSize: 10000000,
          },
          "GET"
        )
        .then((res) => {
          this.loading = false;
          this.exportHistoryoptions = res.rows;
        })
        .catch((err) => {
          console.log(err);
          this.$message.error(err.response.data.message);
        });
    },
    getData(e) {
      this.loading = true;
      e.shopNum = this.$shopData.shopNum;
      e.mchShopNum = this.$shopData.shopNum;
      this.ccRequest
        .do("admin/merchant/waybill/query", e, "POST")
        .then((res) => {
          this.dataArr = res.rows;
          this.results = res.total;
          this.loading = false;
          this.refeshTable = new Date().getTime()
        })
        .catch((err) => {
          console.log(err);
          this.loading = false;
          this.$message.error(err.response.data.message);
        });
    },
    pageChange(e) {
      this.form.pageSize = e.pageSize;
      this.form.pageNo = e.pageNo;
      this.getData(this.form);
      this.ids = [];
    },
    //第一個條件搜索
    formChange1(e) {
      this.form1 = { ...e };
    },
    //第三條件搜索
    formChange3(e) {
      this.form3 = { ...e };
    },
    //時間變化
    changeTime() {
      let start = "";
      let end = "";
      let form2 = {};
      let e = JSON.parse(JSON.stringify(this.checkbox));
      end = getDateGE(0) + " 23:59:59";

      if (this.timeArr) {
        e = JSON.parse(JSON.stringify(this.timeArr));
        start = e[0];
        end = e[1];
      }
      if (this.checkbox.length > 0) {
        if (e.length > 0) {
          let type = e[0];
          if (type == "Today") {
            start = getDateGE(0) + " 00:00:00";
          } else if (type == "Yesterday") {
            start = getDateGE(-1) + " 00:00:00";
            end = getDateGE(-1) + " 23:59:59";
          } else if (type == "Recent 3 Days") {
            start = getDateGE(-3) + " 00:00:00";
          } else if (type == "Recent 7 Days") {
            start = getDateGE(-7) + " 00:00:00";
          } else if (type == "Recent 14 Days") {
            start = getDateGE(-14) + " 00:00:00";
          }
        }
      }

      if (e.length > 0) {
        if (this.sort == "order_time") {
          form2.orderTimeGe = start;
          form2.orderTimeLe = end;
        } else if (this.sort == "pick_up_due_time") {
          form2.pickUpDueTimeGe = start;
          form2.pickUpDueTimeLe = end;
        } else if (this.sort == "pick_up_Time") {
          form2.pickUpTimeGe = start;
          form2.pickUpTimeLe = end;
        } else if (this.sort == "deliver_due_time") {
          form2.deliverDueTimeGe = start;
          form2.deliverDueTimeLe = end;
        } else if (this.sort == "deliver_time") {
          form2.deliverTimeGe = start;
          form2.deliverTimeLe = end;
        } else if (this.sort == "create_time") {
          form2.createTimeGe = start;
          form2.createTimeLe = end;
        } else if (this.sort == "out_pick_confirm_due_time") {
          form2.outPickConfirmDueGe = start;
          form2.outPickConfirmDueLe = end;
        } else if (this.sort == "out_pick_confirm_time") {
          form2.outPickConfirmTimeGe = start;
          form2.outPickConfirmTimeLe = end;
        }
      }

      this.form2 = { ...form2 };
    },
    search() {
      let statuses = [];
      for (const key in this.form1) {
        statuses.push(this.form1[key]);
      }
      let form = {
        ...this.form2,
      };
      form.statuses = statuses.join(",") || undefined;
      form.orderId = this.form3.orderId;
      form.wbNum = this.form3.wbNum;
      form.sort = this.sort || undefined;
      form.isAsc = this.sort2=='ASC'?true:false;
      form.pageSize = 10;
      form.pageNo = 1;
      this.form = form;
      this.getData(form);
      this.$refs.page.init();
    },

    //generate 操作
    generate() {
      this.loading = true;
      this.ccRequest
        .do("admin/merchant/waybill/masterWayBill/generate", {
          shopNum: this.shopData.shopNum,
          mchShopNum: this.shopData.shopNum,
        })
        .then((res) => {
          this.$message.success(this.language("waybillManagement.success"));
          this.getExportHistoryoptions();
          this.getData(this.form);
        })
        .catch((err) => {
          console.log(err);
          this.loading = false;
          this.$message.error(err.response.data.message);
        });
    },
    //Export Master WB
    exportMasterWB() {
      if (this.exportHistoryValue == "") {
        this.$message.error(
          this.language("waybillManagement.exportMasterWBError")
        );
        return false;
      }

      window.open(
        process.env.VUE_APP_exportMasterWB +
          "api/deliver/masterWayBill/mwb?id=" +
          this.exportHistoryValue
      );
      this.$message(this.language("common.downloading"));
    },

    selectingResult(e) {
      let ids = [];
      for (let i = 0; i < e.length; i++) {
        ids.push(e[i].id);
      }
      this.ids = ids;
    },
    checkIds(tips) {
      return new Promise((s, r) => {
        if (this.ids.length == 0) {
          this.$message.error(
            this.language("waybillManagement.pickListItemTips")
          );
          r();
          return false;
        }

        this.$confirm(tips, this.language("waybillManagement.tips"), {
          confirmButtonText: this.language("waybillManagement.confirm"),
          cancelButtonText: this.language("waybillManagement.cancel"),
          type: "warning",
        })
          .then(() => {
            s();
          })
          .catch(() => {
            r();
          });
      });
    },
    //PickingListByItem
    PickingListByItem() {
      if (this.ids.length == 0) {
        this.$message.error(
          this.language("waybillManagement.pickListItemTips")
        );
        return false;
      }
      this.dialog = true;
    },
    //PickingConfirm
    PickingConfirm() {
      this.checkIds(this.language("common.continueTips"))
        .then(() => {
          let data = {
            shopNum: this.shopData.shopNum,
            mchShopNum: this.shopData.shopNum,
            ids: this.ids.join(","),
          };
          this.ccRequest
            .do("admin/merchant/waybill/confirm", data, "POST")
            .then((res) => {
              this.getData(this.form);
              this.ids = [];
              this.$message.success(this.language("waybillManagement.success"));
            })
            .catch((err) => {
              console.log(err);
              this.$message.error(err.response.data.message);
            });
        })
        .catch(() => {});
    },

    //printWB
    printWB() {
      this.checkIds(this.language("common.continueTips"))
        .then(() => {
          let id = "";
          for (let i = 0; i < this.ids.length; i++) {
            id += "&ids=" + this.ids[i];
          }
          window.open(
            process.env.VUE_APP_exportMasterWB +
              "api/deliver/wayBill/deliverWayBill?appId=supnr" +
              id
          );
          this.$message(this.language("common.downloading"));
        })
        .catch(() => {});
    },

    //acknowledge
    acknowledge() {
      this.checkIds(this.language("common.continueTips"))
        .then(() => {
          let data = {
            shopNum: this.shopData.shopNum,
            mchShopNum: this.shopData.shopNum,
            ids: this.ids.join(","),
          };
          this.ccRequest
            .do("admin/merchant/waybill/acknowledge", data, "POST")
            .then((res) => {
              this.getData(this.form);
              this.ids = [];
              this.$message.success(this.language("waybillManagement.success"));
            })
            .catch((err) => {
              console.log(err);
              this.$message.error(err.response.data.message);
            });
        })
        .catch(() => {});
    },
    //print
    print() {
      this.checkIds(this.language("common.continueTips"))
        .then(() => {
          this.loading = true;
          let data = {
            shopNum: this.shopData.shopNum,
            mchShopNum: this.shopData.shopNum,
            ids: this.ids.join(","),
          };
          this.ccRequest
            .do("admin/merchant/waybill/pick", data, "POST")
            .then((res) => {
              this.loading = false;
              this.getData(this.form);
              this.ids = [];
              this.$message.success(this.language("waybillManagement.success"));
            })
            .catch((err) => {
              this.loading = false;
              console.log(err);
              this.$message.error(err.response.data.message);
            });
        })
        .catch(() => {});
    },
    //Cancel
    cancel() {
      this.checkIds(this.language("common.continueTips"))
        .then(() => {
          this.loading = true;
          let data = {
            shopNum: this.shopData.shopNum,
            mchShopNum: this.shopData.shopNum,
            ids: this.ids.join(","),
          };
          this.ccRequest
            .do("admin/merchant/waybill/cancel", data, "POST")
            .then((res) => {
              this.loading = false;
              this.getData(this.form);
              this.ids = [];
              this.$message.success(this.language("waybillManagement.success"));
            })
            .catch((err) => {
              this.loading = false;
              console.log(err);
              this.$message.error(err.response.data.message);
            });
        })
        .catch(() => {});
    },
    //Delay
    delay() {
      this.checkIds(this.language("common.continueTips"))
        .then(() => {
          let data = {
            shopNum: this.shopData.shopNum,
            mchShopNum: this.shopData.shopNum,
            ids: this.ids.join(","),
          };
          this.loading = true;
          this.ccRequest
            .do("admin/merchant/waybill/delay", data, "POST")
            .then((res) => {
              this.loading = false;
              this.getData(this.form);
              this.ids = [];
              this.$message.success(this.language("waybillManagement.success"));
            })
            .catch((err) => {
              this.loading = false;
              console.log(err);
              this.$message.error(err.response.data.message);
            });
        })
        .catch(() => {});
    },
  },
  mounted() {
    this.shopData = this.$shopData;
    this.getData({
      pageSize: 10,
      pageNo: 1,
      isAsc:false
    });
    this.getExportHistoryoptions();
  },
};
</script>
<style scoped lang="scss">
.padding {
  margin-top: 20px;
}
.card_wrap {
  background: #f7f7f7;
  padding: 20px;
  h5 {
    font-size: $sbuTitle;
    margin: 10px 0 20px 0;
  }
  .card {
    margin-top: 10px;
    display: flex;
    .card1 {
      width: 400px;
      margin-right: 20px;
      .button {
        margin: 10px 0;
      }
    }
    .card2 {
      width: 450px;
      .button {
        margin: 10px 0 10px 10px;
      }
    }
  }
  .status {
    flex: 2;
  }

  .input {
    flex: 1;
  }
  .select_time {
    display: flex;
    align-items: center;
    margin-bottom: 10px;
    .select_time_tips {
      display: flex;
      align-items: center;
      color: red;
      margin-left: 10px;
    }
    .title {
      width: 100px;
    }
  }
}
.tips {
  margin-top: 10px;
  font-size: $sbuTitle;
}
.button_wrap {
  margin-top: 20px;
}
.box-card {
  margin-left: 20px;
  margin-right: 20px;
  height: 100%;
  // width: 570px;
}
.check_box {
  margin-top: 10px;
  width: 130px;
}
.time {
  margin-top: 10px;
  width: 100%;
}
.time_wrap {
  display: flex;
}
.checkbox_items {
  margin: 5px 0;
}
.table_wrap {
  margin-top: 50px;
  .count {
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: $sbuTitle;
    margin-bottom: 20px;
    font-weight: 600;
    .title {
      margin-right: 100px;
      // font-size: $title;
    }
  }
}
.table_wrap {
  .button_box {
    display: flex;
  }
  .button_wrap {
    margin-bottom: 20px;
    display: flex;
    align-items: center;
    .title {
      margin-right: 10px;
      font-size: $title;
    }
  }
  .button_wrap_2 {
    margin-left: 100px;
  }
}
</style>